export enum RequestType{
    GET = 'get',
    POST = 'post'
}